import { ReactNode } from "react";
import { Skeleton, SkeletonProps } from "@mui/material";
import { ReduxStateType } from "redux-store/types";

interface Props extends SkeletonProps {
  status: ReduxStateType;
  children: ReactNode;
  hidden?: boolean;
}

const SkeletonWrapper = ({
  status = ReduxStateType.LOADING,
  children,
  hidden = false,
  ...props
}: Props) => {
  return status === ReduxStateType.LOADING ? (
    <Skeleton {...props} />
  ) : (
    <>{!hidden && children}</>
  );
};

export default SkeletonWrapper;
